export const IconArrowLink20Bold: {
  name: 'icon_arrow_link_20_bold-4701c168b15c'
} = {
  name: 'icon_arrow_link_20_bold-4701c168b15c'
}
